@if (pdfUrl) {
  <section class="tos-page">
    <div class="tos-actions">
      <button class="tos-action-button" type="button" (click)="goBack()">
        {{ 'TOS_PAGE.GO_BACK' | translate }}
      </button>
      <a [href]="pdfUrl" [attr.target]="openLinkTarget" class="tos-action-button" rel="noopener noreferrer">
        {{ 'TOS_PAGE.OPEN_DOCUMENT' | translate }}
      </a>
    </div>
    @if (shouldRenderInlineViewer) {
      <object class="tos-frame" [data]="safePdfUrl" type="application/pdf">
        <iframe class="tos-frame" [src]="safePdfUrl" [title]="'TOS_PAGE.TITLE' | translate"></iframe>
      </object>
    } @else {
      <div class="tos-fallback">
        <div class="tos-fallback-card">
          <h1 class="tos-title">{{ 'TOS_PAGE.TITLE' | translate }}</h1>
          <p class="tos-text">{{ 'TOS_PAGE.MOBILE_DESCRIPTION' | translate }}</p>
        </div>
      </div>
    }
  </section>
} @else {
  <div class="tos-fallback">{{ 'TOS_PAGE.UNAVAILABLE' | translate }}</div>
}
